module.exports = __webpack_public_path__ + "img/DSC_7030-Edit-4-1.5dbde68a.5dbde68a.jpg";